import styled from "@emotion/styled";

import { IconBase } from "./IconBase";

import icon from "@/content/icons/BicstoneIcon.svg";

export const BicstoneIcon = styled(IconBase)({
  content: `url(${icon})`,
});
